import { CustomPermissions, MenuRolePermissions } from '@centric-os/types';

// Mirror of ap3-only scopes from `clients/ap3/src/constants.js`. ap3 is
// sunsetted; safe to drop once decommissioned.
const Ap3OnlyCustomPermissions = [
  '*:announcement:*',
  'report:c360:*',
  'report:c360:product_mix',
  'report:c360:sales_distribution',
  'report:c360:sales_summary',
] as const;

// FE allowlist for `PUT /user/{id}/permissions`, stored as `(action, type)`
// pairs so concrete-id scopes (e.g. `read:global_menu_group:<id>`) match
// against their templated allowlist entry (`read:global_menu_group:*`).
// Role-assignment scopes (`*_role:*:*`) and god-mode (`*:*:*`) are handled
// inline in `removeDeprecatedScopes`.
const KnownActionTypes: ReadonlySet<string> = new Set<string>(
  [
    ...Object.values(CustomPermissions),
    ...Object.values(MenuRolePermissions).flat(),
    ...Ap3OnlyCustomPermissions,
  ].map((s) => {
    const [action = '*', type = '*'] = s.split(':');
    return `${action}:${type}`;
  }),
);

const ROLE_ACTION_SUFFIX = '_role';

export function removeDeprecatedScopes(
  scopes: readonly string[] | undefined | null,
): string[] {
  if (!Array.isArray(scopes)) return [];
  return scopes.filter((scope) => {
    if (typeof scope !== 'string') return false;
    const [action = '*', type = '*'] = scope.split(':');
    if (action === '*' && type === '*') return true;
    if (action.endsWith(ROLE_ACTION_SUFFIX)) return true;
    return (
      KnownActionTypes.has(`${action}:${type}`) ||
      KnownActionTypes.has(`*:${type}`) ||
      KnownActionTypes.has(`${action}:*`)
    );
  });
}
